import HeaderBar from "../../../components/header/headerBar";
import { SearchFieldSelect } from "../../../components/textfield";
import { useEffect, useState } from "react";
import "../../../assets/styles/admin/barthervat.scss";
import MainButton from "../../../components/button/mainButton";
import IconMdi from "@mdi/react";
import { mdiPlus, mdiDelete, mdiPencilCircle } from "@mdi/js";
// import { Table, TableColumn } from "../../../components/table";
import EmptyModel from "../../../components/modal/emptyModal";
import { Icon } from "@iconify/react";

import {
  Select,
  Input,
  Form,
  Checkbox,
  Radio,
  Button,
  InputNumber,
  Modal,
  DatePicker,
  Space,
  Table,
  Row,
  Col,
} from "antd";

import moment from "moment";

import { format } from "path";
import axios from "axios";
import { numberWithCommas } from "../../../helpers/functions";

const BartherVat = () => {
  const { confirm } = Modal;
  const [isOpen, setIsOpen] = useState(false);
  const [dataBarther, setDataBarther] = useState<any>([]);
  const [typeTitle, setTypeTitle] = useState<string>("Create");
  const [updateId, setUpdateId] = useState<string>("");
  ////////////////////////////////////////////////////////////////////////////////////////////////////////
  const [form] = Form.useForm();
  const [isValidate, setIsvalidate] = useState<any>({
    code: false,
    details: false,
  });
  ////////////////////////////////////////////////////////////////////////////////////////////////////////
  const monthType = [
    { value: "all", label: "All" },
    { value: "select", label: "SELECT MONTH" },
  ];
  const option = [{ value: "name", name: "Name" }];
  const branch = [
    { value: "", name: "All" },
    { value: "1", name: "1" },
    { value: "2", name: "2" },
  ];

  const month = [
    { value: "", name: "All" },
    { value: "1", name: "1" },
    { value: "2", name: "2" },
  ];

  const columns = [
    {
      title: "",
      dataIndex: "",
      align: "center" as const,
      render: (text: any, record: any, index: number) => {
        return index + 1;
      },
    },
    {
      title: "Code",
      dataIndex: "code",
    },
    {
      title: "BarterDetail",
      dataIndex: "detail",
    },
    {
      title: "PriceCredit",
      dataIndex: "credit",
      align: "center" as const,
      render: (text: any, record: any) => {
        return numberWithCommas(text, 2);
      },
    },
    {
      title: "DateStart / DateEnd",
      dataIndex: "startDate",
      align: "center" as const,
      width: "11%",
      render: (text: any, record: any) => {
        return (
          <>
            {record?.startDate &&
              (record?.startDate).substring(0, 10) + " - " + record?.endDate &&
              (record?.endDate).substring(0, 10)}
          </>
        );
      },
    },
    {
      title: "Action",
      colspan: 2,
      align: "center" as const,
      render: (text: any) => (
        <Space size="large">
          <div
            onClick={() => {
              setTypeTitle("Update");
              getOneById(text._id);
            }}
          >
            <Icon
              icon="el:pencil-alt"
              width="1.2rem"
              height="1.2rem"
              color="#5BAEA9"
            />
          </div>

          <div onClick={() => showDeleteConfirm(text?._id, text?.name)}>
            <Icon
              icon="fa-solid:trash-alt"
              width="1.2rem"
              height="1.2rem"
              color="#FF6760"
            />
          </div>
        </Space>
      ),
    },
  ];

  ////////////////////////////////////////////////////////////////////////////////////////////////////
  const deleteData = async (id: any) => {
    await axios.delete(`/barthers/${id}`).then((res) => {
      setTimeout(() => getDataBarther(), 200);
    });
  };

  const onBlurInput = (name: any) => {
    if (
      form.getFieldValue(name) === undefined ||
      form.getFieldValue(name) === ""
    ) {
      const test = { ...isValidate };
      test[name] = true;
      setIsvalidate(test);
    } else {
      const test = { ...isValidate };
      test[name] = false;
      setIsvalidate(test);
    }
    console.log(name);
    console.log(isValidate[name]);
  };

  const onFinish = async (values: any) => {
    // console.log("Success:", values);
    if (typeTitle === "Create") {
      Createbarther(values);
    } else if (typeTitle === "Update") {
      updateData(values);
    }
  };
  const onFinishFailed = (errorInfo: any) => {
    console.log("Failed:", errorInfo);
  };

  const onChangPrieTranfer = (event: any) => {
    const { value } = event.target;
    // console.log(editPrieTranfer);
    const reg = /^-?\d*(\d*)?$/;
    if ((!isNaN(value) && reg.test(value)) || value === "" || value === "-") {
      form.setFieldsValue({ value: value });
    }
  };

  const Createbarther = async (values: any) => {
    const body = {
      code: values.code,
      name: values.code,
      detail: values.details,
      credit: values.value,
      startDate: moment(values.startDate).utcOffset(0, true),
      endDate: moment(values.expirationDate).utcOffset(0, true),
    };

    try {
      await axios
        .post(`${process.env.REACT_APP_BASE_URL}/barthers`, body)
        .then((ress) => {
          setIsOpen(false);
          form.resetFields();
          getDataBarther();
        });
    } catch (err) {
      console.log(err);
      return;
    }
  };
  ////////////////////////////////////////////////////////////////////////////////////////////////////

  const OnChangeOtherd = (value: any) => {
    console.log("SEARCH => ", value);
  };

  const getAPIs = () => {
    getDataBarther();
  };
  const getDataBarther = async () => {
    axios.get(`/barthers`).then((ress) => {
      const datas = ress?.data?.data;
      setDataBarther(datas);
    });
  };
  const getOneById = async (_id: any) => {
    axios.get(`/barthers/${_id}`).then((res) => {
      const xDatas = res?.data;

      setUpdateId(xDatas?._id);
      form.setFieldsValue({
        code: xDatas?.code,
        details: xDatas?.detail,
        value: xDatas?.credit,
        startDate: moment(xDatas?.startDate),
        expirationDate: moment(xDatas?.endDate),
      });

      setIsOpen(true);
    });
  };

  const updateData = async (values: any) => {
    const body = {
      code: values.code,
      name: values.code,
      detail: values.details,
      credit: values.value,
      startDate: moment(values.startDate).utcOffset(0, true),
      endDate: moment(values.expirationDate).utcOffset(0, true),
    };

    try {
      await axios
        .patch(`${process.env.REACT_APP_BASE_URL}/barthers/${updateId}`, body)
        .then(() => {
          setIsOpen(false);
          form.resetFields();
          getDataBarther();
        });
    } catch (err) {
      console.log(err);
      return;
    }
  };

  function onClose() {
    setIsOpen(false);
  }

  function showDeleteConfirm(id: any, name: any) {
    confirm({
      title: "",
      content: (
        <>
          <div>
            <Icon
              icon="lucide:alert-circle"
              color="#FF6760"
              width="10.6%"
              height="10.6%"
              style={{ marginBottom: "28px" }}
            />
          </div>
          <div>{`ต้องการลบ ${name} ออกหรือไม่ ?`}</div>
          <div>{`Are you sure delete ${name} from list?`}</div>
        </>
      ),
      // content: "Some descriptions",
      autoFocusButton: null,
      okText: "ตกลง / Submit",
      okType: "danger",
      cancelText: "ยกเลิก / Cancel",
      onOk() {
        deleteData(id);
      },
      width: "fit-content",
    });
  }

  useEffect(() => {
    getAPIs();
  }, []);
  return (
    <>
      <HeaderBar title="BARTHER (VAT) LIST" />
      <div style={{ padding: "10px 40px" }}>
        <Form
          name="basic"
          initialValues={{ remember: true }}
          autoComplete="off"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          form={form}
        >
          <EmptyModel width="50%" show={isOpen} onClose={onClose}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                padding: "20px 40px",
              }}
            >
              <h4 style={{ fontSize: "20px", marginBottom: 25 }}>
                {typeTitle} Barther (Vat)
              </h4>
              <div style={{ marginBottom: 15 }}>
                <label
                  style={{
                    color: "#5BAEA9",
                    marginBottom: 5,
                    fontSize: 14,
                    fontWeight: 500,
                    paddingLeft: 0,
                  }}
                >
                  รหัส Barther (Vat)
                </label>
                <Form.Item name="code">
                  <Input
                    className={isValidate.code === true ? "validate-input" : ""}
                    onBlur={() => onBlurInput("code")}
                  />
                </Form.Item>
              </div>
              <div style={{ marginBottom: 15 }}>
                <label
                  style={{
                    color: "#5BAEA9",
                    marginBottom: 5,
                    fontSize: 14,
                    fontWeight: 500,
                    paddingLeft: 0,
                  }}
                >
                  รายละเอียด / Detail
                </label>
                <Form.Item name="details">
                  <Input
                    className={
                      isValidate.details === true ? "validate-input" : ""
                    }
                    onBlur={() => onBlurInput("details")}
                  />
                </Form.Item>
              </div>
              <div style={{ marginBottom: 15 }}>
                <label
                  style={{
                    color: "#5BAEA9",
                    marginBottom: 5,
                    fontSize: 14,
                    fontWeight: 500,
                    paddingLeft: 0,
                  }}
                >
                  มูลค่า / Price Credit
                </label>
                <Form.Item name="value">
                  <Input type="number" />
                </Form.Item>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  marginBottom: 15,
                }}
              >
                <label
                  style={{
                    color: "#5BAEA9",
                    marginBottom: 5,
                    fontSize: 14,
                    fontWeight: 500,
                    paddingLeft: 0,
                  }}
                >
                  วันที่ออก / Date Start
                </label>
                <Form.Item name="startDate">
                  <DatePicker
                    style={{
                      width: "100%",
                      borderBottom: "2px solid #d9d9d9",
                      borderTop: 0,
                      borderRight: 0,
                      borderLeft: 0,
                    }}
                    format={"DD-MM-YYYY"}
                    placeholder=""
                  />
                </Form.Item>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  marginBottom: 15,
                }}
              >
                <label
                  style={{
                    color: "#5BAEA9",
                    marginBottom: 5,
                    fontSize: 14,
                    fontWeight: 500,
                    paddingLeft: 0,
                  }}
                >
                  วันหมดอายุ / Date End
                </label>
                <Form.Item name="expirationDate">
                  <DatePicker
                    style={{
                      width: "100%",
                      borderBottom: "2px solid #d9d9d9",
                      borderTop: 0,
                      borderRight: 0,
                      borderLeft: 0,
                    }}
                    format={"DD-MM-YYYY"}
                    placeholder=""
                  />
                </Form.Item>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-around",
                  marginTop: 35,
                }}
              >
                <Form.Item style={{ width: "40%" }}>
                  <Button
                    onClick={() => {
                      setIsOpen(false);
                    }}
                    style={{
                      width: "100%",
                      height: 50,
                      background: "#E76464",
                      borderRadius: 4,
                      color: "white",
                    }}
                  >
                    ยกเลิก / Cancel
                  </Button>
                </Form.Item>
                <Form.Item style={{ width: "40%" }}>
                  <Button
                    htmlType="submit"
                    style={{
                      width: "100%",
                      height: 50,
                      background: "#4D7E7F",
                      borderRadius: 4,
                      color: "white",
                    }}
                  >
                    บันทึกข้อมูล/Submit
                  </Button>
                </Form.Item>
              </div>
            </div>
          </EmptyModel>
        </Form>
        <SearchFieldSelect
          option={option}
          placeholder=""
          color="#FFF"
          onChangeOtherd={OnChangeOtherd}
        />
        <div className="row mt-20">
          <div className="bartherWapper">
            <div className="barther-select"></div>
            <div style={{ display: "flex" }}>
              <MainButton
                title="Create Barther (Vat)"
                onClick={() => {
                  setTypeTitle("Create");

                  setIsOpen(true);
                  form.resetFields();
                }}
              >
                <IconMdi path={mdiPlus} size="24" color="#FFF" />
              </MainButton>
            </div>
          </div>
        </div>
        <div style={{ marginTop: "20px" }} className="table-data-barther">
          <Table
            dataSource={dataBarther}
            columns={columns}
            rowKey="_id"
            bordered
            scroll={{ x: 100 }}
          />
        </div>
      </div>
    </>
  );
};
export default BartherVat;
